module.exports = __webpack_public_path__ + "img/walk_opac.74964041.svg";